import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserProfileService } from '../../../api/user-profile.service';
@Component({
  selector: 'iv-sub-tabs',
  templateUrl: './subtabs.component.html',
  styleUrls: ['./subtabs.component.scss']
})
export class SubtabsComponent {
  @Input() tabs;
  @Input() parentStatus;
  @Input() selectedTransType;
  @Input() basePath;
  @Input() viewStatus;
  startDate;
  endDate;
  query;
  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private userProfileService: UserProfileService) {
    if (this.activatedRoute.snapshot.queryParams) {
      this.startDate = this.activatedRoute.snapshot.queryParams.start_date;
      this.endDate = this.activatedRoute.snapshot.queryParams.end_date;
      this.query = this.activatedRoute.snapshot.queryParams.q;
    }
  }
  navigateRoutes(transId) {
    const queryParams: any = {};

    if (this.startDate && this.endDate) {
      queryParams.start_date = this.startDate;
      queryParams.end_date = this.endDate;
    }

    if (this.query) {
      queryParams.q = this.query;
    }
    if (this.viewStatus) {
      queryParams.view = this.viewStatus;
    }

    if (this.basePath === 'transaction-summary') {
      this.router.navigate([`/${this.basePath}/${transId}`], {
        queryParams: queryParams
      });
    } else {
      this.router.navigate([`/${this.basePath}/${this.parentStatus}/${transId}`], {
        queryParams: queryParams
      });
    }
  }

  getUserCountry() {
    return this.userProfileService.getCountryLocalStorage();
  }
}
